import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {


    init() {
        super.init();

        window.addEventListener("pegasus-grid-filter-toggle", (event) => {
            this.currentFilters = event.detail.currentFilters;
            this.fetchContent();
        });
    }

    fetchContent(href = null){
        const postGridContainer = this.postGrid.querySelector('[data-pegasus-filterable]');
        if (!postGridContainer) return;

        const elements = ['data-pegasus-filterable="'+ postGridContainer.dataset.pegasusFilterable +'"'];
        let currentUrl = '';

        if(!Object.keys(this.currentFilters).length){
            if(href){
                currentUrl = href;
            } else {
                window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
                return;
            }
        } else {
            currentUrl = this.buildUrl();
        }

        if(href){
            currentUrl = href; 
        }

        if(!this.isLoading){
            this.isLoading = true;

            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;
                history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);

                const offset = 150;
                const top = this.postGrid.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });

                if(typeof window.modal !== "undefined"){
                    window.modal.init();
                }

            });
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", () => new PostGrid());
});
